import { openModal } from '@core/components/ModalStack';
import { AddEditProviderBillModalProps } from './AddEditProviderBillModal';

export async function openAddEditProviderBillModal(props: AddEditProviderBillModalProps) {
  const { AddEditProviderBillModal } = await import('./AddEditProviderBillModal');

  openModal(AddEditProviderBillModal, props);
}
